'use client'

import { LazyMotion, domAnimation, m, useAnimation } from 'framer-motion'
import * as React from 'react'

export function ShowMore({
  children,
  showLessText,
  showMoreText,
}: PropsWithChildren<{ showMoreText: string; showLessText: string }>) {
  const [showMore, setShowMore] = React.useState(false)
  const controls = useAnimation()

  const variants = {
    open: { height: showMore ? 'auto' : 'var(--show-more-height)' },
    collapsed: { height: 'var(--show-more-height)' },
  }

  React.useEffect(() => {
    if (showMore) {
      controls.start('open')
    } else {
      controls.start('collapsed')
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showMore])

  return (
    <LazyMotion features={domAnimation}>
      <m.div
        initial={showMore ? 'open' : 'collapsed'}
        animate={controls}
        variants={variants}
        transition={{ duration: 0.8 }}
        className="overflow-hidden [--show-more-height:75px] lg:[--show-more-height:82px]"
      >
        {children}
      </m.div>
      <div className="mt-[10px] flex">
        <span
          onClick={() => setShowMore(!showMore)}
          className="text-14 w-fit cursor-pointer underline"
        >
          {showMore ? showLessText : showMoreText}
        </span>
      </div>
    </LazyMotion>
  )
}
